import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from 'react';
var SvgCamera = function SvgCamera(props) {
  return __jsx("svg", _extends({
    height: "21",
    viewBox: "0 0 25 21",
    width: "25",
    xmlns: "http://www.w3.org/2000/svg"
    // xmlns:xlink='http://www.w3.org/1999/xlink'
  }, props), __jsx("mask", {
    id: "a",
    fill: "#fff"
  }, __jsx("path", {
    d: "m.625.67h1.268v4.014h-1.268z",
    fill: "#fff",
    fillRule: "evenodd"
  })), __jsx("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -.5)"
  }, __jsx("path", {
    d: "m7.842 6.074c.212-.392.773-.642 1.197-.642h5.341c.424 0 .984.25 1.196.642l.89 1.307c.177.356.532.605.956.605h2.848c.637 0 1.133.535 1.133 1.14v8.927c0 .64-.53 1.14-1.133 1.14h-17.016a1.144 1.144 0 0 1 -1.132-1.14v-8.963c0-.642.53-1.14 1.132-1.14h2.92c.14-.036.319-.072.424-.143a.689.689 0 0 0 .318-.32l.926-1.414zm9.951-.297-.442-.7c-.566-1.105-1.663-1.817-2.936-1.817h-5.34c-1.239 0-2.37.712-2.936 1.816l-.483.701h-2.402a3.257 3.257 0 0 0 -3.254 3.278v8.998a3.257 3.257 0 0 0 3.254 3.277h17.016a3.257 3.257 0 0 0 3.255-3.277v-8.963c0-1.817-1.45-3.314-3.255-3.314h-2.477z",
    fill: "#b2bdc4"
  }), __jsx("ellipse", {
    cx: "11.979",
    cy: "13.095",
    rx: "3.646",
    ry: "3.667",
    stroke: "#b2bdc4",
    strokeWidth: "2.074"
  }), __jsx("g", {
    fill: "#b2bdc4"
  }, __jsx("path", {
    d: "m18.834 4.52-.769-1.235a.62.62 0 0 1 .193-.848.61.61 0 0 1 .842.195l.769 1.235a.619.619 0 0 1 -.193.847.61.61 0 0 1 -.842-.194"
  }), __jsx("path", {
    d: "m1.26 4.684a.638.638 0 0 1 -.635-.639v-2.735c0-.352.286-.64.635-.64.348 0 .633.288.633.64v2.735a.638.638 0 0 1 -.633.639",
    mask: "url(#a)",
    transform: "translate(20.265 .124)"
  }), __jsx("path", {
    d: "m23.118 3.958.64-1.308a.611.611 0 0 1 .818-.28c.3.15.426.521.277.825l-.64 1.307a.61.61 0 0 1 -.818.279.619.619 0 0 1 -.277-.823"
  }))));
};
export default SvgCamera;